import { BriefAiOverviewStatus } from "@shared/lib/types/brief";
import { useQuery } from "@tanstack/react-query";
import { BRIEF_AI_OVERVIEW_QUERY_KEY } from "../../constants";
import { BriefService } from "../../services/brief.service";

export function useGetBriefAIOverview(briefId: string, overviewId: string) {
  const { data, isLoading, error, isSuccess, isFetched, refetch } = useQuery({
    queryKey: BRIEF_AI_OVERVIEW_QUERY_KEY(briefId, overviewId),
    queryFn: () => BriefService.getBriefAiOverview(overviewId),
    enabled: !!briefId && !!overviewId,
    refetchInterval: (query) => {
      const status = query?.state?.data?.data?.status;
      const shouldPoll = status === BriefAiOverviewStatus.Pending;
      return shouldPoll ? 1000 : undefined;
    },
  });

  return {
    briefAiOverview: data?.data,
    isFetching: isLoading,
    isError: error,
    isSuccess: isSuccess,
    isFetched: isFetched,
    refetch: refetch,
  };
}
